/*
  Regalo del Buen Fin: el kit de limpieza entra solo en el carrito cuando hay calzado.

  El descuento automático FREEKIT (Buy X get Y) es quien lo deja en cero; este
  archivo sólo se encarga de que el kit esté en el carrito sin que el cliente lo
  busque, y de retirarlo cuando ya no corresponde.

  Reglas, 4 de noviembre de 2026:
  - Dispara cualquier producto de calzado. NO disparan agujetas, playeras ni el
    propio kit: son los mismos 19 productos que FREEKIT deja fuera.
  - Uno por pedido. Si el cliente sube la cantidad, vuelve a 1.
  - Si se queda sin calzado, el kit sale del carrito.
  - Se apaga solo al acabar noviembre de 2026.

  No depende de los eventos internos del tema: envuelve fetch y ajusta el carrito
  antes de devolver la respuesta, así el cajón que pinta el tema ya sale correcto.
*/
(function () {
  'use strict';

  var VARIANTE = 68070605160812;          // Kit de limpieza para calzado · KIT-LIMP-01
  var FIN = Date.parse('2026-12-01T00:00:00-06:00');
  var SIN_REGALO = ['agujetas', 'playeras', 'kit de limpieza'];

  var ocupado = false;

  function vigente() {
    return isFinite(FIN) && Date.now() < FIN;
  }

  function dispara(item) {
    if (item.variant_id === VARIANTE) return false;
    var t = String(item.product_type || '').toLowerCase().trim();
    for (var i = 0; i < SIN_REGALO.length; i++) {
      if (t === SIN_REGALO[i]) return false;
    }
    return true;
  }

  function pedir(url, cuerpo) {
    var opciones = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) };
    return (window.__ulFetchOriginal || window.fetch).call(window, url, opciones);
  }

  function carrito() {
    return (window.__ulFetchOriginal || window.fetch)
      .call(window, '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Devuelve true si tocó el carrito.
  function ajustar() {
    if (ocupado || !vigente()) return Promise.resolve(false);
    ocupado = true;
    return carrito()
      .then(function (c) {
        var items = (c && c.items) || [];
        var regalo = null;
        var hayCalzado = false;
        for (var i = 0; i < items.length; i++) {
          if (items[i].variant_id === VARIANTE) regalo = items[i];
          else if (dispara(items[i])) hayCalzado = true;
        }
        if (hayCalzado && !regalo) {
          return pedir('/cart/add.js', { items: [{ id: VARIANTE, quantity: 1 }] }).then(function () { return true; });
        }
        if (!hayCalzado && regalo) {
          return pedir('/cart/change.js', { id: regalo.key, quantity: 0 }).then(function () { return true; });
        }
        if (regalo && regalo.quantity > 1) {
          return pedir('/cart/change.js', { id: regalo.key, quantity: 1 }).then(function () { return true; });
        }
        return false;
      })
      .catch(function () { return false; })
      .then(function (cambio) { ocupado = false; return cambio; });
  }

  // Envoltura de fetch: tras cualquier escritura del carrito, ajustamos antes de
  // devolver la respuesta, para que lo que el tema pinte después ya esté bien.
  if (!window.__ulFetchOriginal) {
    window.__ulFetchOriginal = window.fetch;
    window.fetch = function (recurso, opciones) {
      var url = '';
      try { url = typeof recurso === 'string' ? recurso : (recurso && recurso.url) || ''; } catch (e) { url = ''; }
      var escritura = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !ocupado;
      var promesa = window.__ulFetchOriginal.apply(window, arguments);
      if (!escritura) return promesa;
      return promesa.then(function (respuesta) {
        return ajustar().then(function () { return respuesta; });
      });
    };
  }

  // Formularios clásicos y primera carga.
  function alCargar() {
    ajustar().then(function (cambio) {
      if (cambio && /^\/cart(\/|$)/.test(window.location.pathname)) window.location.reload();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alCargar);
  } else {
    alCargar();
  }
})();
